import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

interface NotificacionCount {
  total: number;
  por_categoria?: Record<string, number>;
}

export function useNotificacionCount() {
  return useQuery<NotificacionCount>({
    queryKey: ['notificaciones', 'count'],
    queryFn: () => api.get<NotificacionCount>('/notificaciones/count'),
    refetchInterval: 120_000, // Fallback poll every 2min (WS handles real-time)
    staleTime: 30_000,
  });
}
